export const GENERAL_AUDIT_LOGS_OPEN_MODAL = "GENERAL_AUDIT_LOGS_OPEN_MODAL";
export const GENERAL_AUDIT_LOGS_SEARCH_REQUEST = "GENERAL_AUDIT_LOGS_SEARCH_REQUEST";
export const GENERAL_AUDIT_LOGS_SEARCH_RESULT = "GENERAL_AUDIT_LOGS_SEARCH_RESULT";
export const GENERAL_AUDIT_LOGS_SEARCH_MODULES_REQUEST = "GENERAL_AUDIT_LOGS_SEARCH_MODULES_REQUEST";
export const GENERAL_AUDIT_LOGS_SEARCH_MODULES_RESULT = "GENERAL_AUDIT_LOGS_SEARCH_MODULES_RESULT";